import React, { useState, useEffect } from 'react';

export default function useStateSearch() {
  const [states, setStates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const getStates = async () => {
      setIsLoading(true);

      try  {
        const response = await fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome');
        const data = await response.json();

        if(!isMounted) {
          return;
        }

        setStates(data?.map(state => ({
          uf: state?.sigla,
          name: state?.nome,
        })));
      } catch(error) {
        console.log(error);
      } finally {
        if(!isMounted) {
          return;
        }

        setIsLoading(false);
      }
    }

    getStates();

    return () => { isMounted = false }
  }, []);

  return {
    states,
    isLoading
  }
}